module.exports = __webpack_public_path__ + "img/pic_12.a53de373.jpg";